import { SyntheticEvent, useState } from "react";
import { useUiStore } from "src/components/main/uiStore";
//--------------------------------------------------------------------------------------------------------------------
import Modal from "src/components/common/Modal";
import Profile from "src/components/common/profile";
import { json } from "src/components/common/types";
import { useAuthStore, User } from "src/components/main/authStore";
import { myAxios, testerEmails } from "src/components/common/functions";
import { useUploadStore } from "../main/uploadStore";
//--------------------------------------------------------------------------------------------------------------------
export default function UserInfoModal({
    closeIt, 
    actionKey, 
    user, 
    editPhoto, 
    editTheme, 
}:{
    closeIt: Function, 
    user: Partial<User>, 
    actionKey?: string, 
    editPhoto?: boolean, 
    editTheme?: boolean, 
}){
    const upload = useUploadStore();
    const setUserInfo = useAuthStore(state => state.setUserInfo);
    const curUser = useAuthStore(state => state.user);
    const [profile, setProfile] = useState(user.profileUrl);
    const setShowLoader = useUiStore(state => state.setShowLoader);
    const [curUserTheme, setUserTheme] = useState(user.userTheme);
    const handleFormSubmit = async (e: SyntheticEvent) => {
        e.preventDefault();
        const formData = new FormData(e.currentTarget as HTMLFormElement);
        const file = formData.get("profile")! as File;
        formData.delete("profile");
        if(file.name){
            // formData.append("curUserId", user.id);
            formData.append("fileName", file.name);
            formData.append("fileType", file.type);
            formData.append("fileSize", String(file.size));
            formData.append("lastModifiedAt", (new Date(file.lastModified)).toISOString().slice(0, 19).replace('T', ' '));
            //-------------------------------------------------------------
            setShowLoader(true);
            const preRes: false | json = await myAxios({ fileName: "auth/updateProfile.php", formData: formData });
            setShowLoader(false);
            if(!preRes) return;
            upload.setFiles([file]);
            upload.setUrls([preRes.data.url]);
            upload.setIds([preRes.data.id]);
            upload.setShow(true);
            upload.setOnResetCallback(() => {
                setUserInfo({profileUrl: profile});
            })
        }else if(profile === ""){
            //-------------------------------------------------------------
            setShowLoader(true);
            const res: false | json = await myAxios({ fileName: "auth/deleteProfile.php", formData: formData });
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------------------
            setUserInfo({profileUrl: ""});
        }
        if(user.userTheme !== curUserTheme){
            //-------------------------------------------------------------
            setShowLoader(true);
            const res: false | json = await myAxios({ fileName: "auth/updateTheme.php", formData: formData });
            setShowLoader(false);
            if(!res) return;
            //-------------------------------------------------------------
            setUserInfo({userTheme: curUserTheme});
        }
        setShowLoader(false);
        closeIt();
        setProfile("");
        return;
    }
    const inputAction = (e: SyntheticEvent) => {
        const reader:FileReader = new FileReader();
        const input = e.currentTarget as HTMLInputElement;
        const file = input.files![0];
        reader.onload = () => {
            if(typeof reader.result !== "object"){
                setProfile(reader.result);
            }
        }
        if(file) reader.readAsDataURL(file);
    }
    return(
        <Modal
            closeIt = {closeIt}
            title = "User Information"
            width = {500}
            maxWidth = {"100%"}
            actionKey = {actionKey}
            handleFormSubmit = {handleFormSubmit}
        >
            <table className = "table" style = {{"userSelect": testerEmails.includes(curUser!.email!)?"text":undefined}}>
                <tbody>
                    <tr>
                        <td>Photo:</td>
                        <td className = "userImg">
                            <Profile
                                value = {profile!}
                                side = {100}
                            />
                            {editPhoto?
                            <div>
                                <span className = "btn btn-primary">
                                    <span>Upload</span>
                                    <input
                                        name = "profile"
                                        type = "file"
                                        accept = "image/png, image/jpeg"
                                        onChange = {inputAction}
                                    />
                                </span>
                                <span
                                    className = "btn btn-danger"
                                    onClick = {() => {
                                        setUserInfo({profileUrl: ""});
                                        setProfile("");
                                    }}>
                                        Delete
                                    </span>
                            </div>:null}
                        </td>
                    </tr>
                    <tr><td>Name:</td><td>{user.userName}</td></tr>
                    <tr><td>Region:</td><td>{user.region}</td></tr>
                    <tr><td>Union:</td><td>{user.unionName} {user.phaseLevel}</td></tr>
                    <tr><td>Department:</td><td>{user.department}</td></tr>
                    <tr><td>Role:</td><td>{user.role}</td></tr>
                    <tr><td>Phone Number:</td><td>{user.phoneNumber}</td></tr>
                    <tr><td>Email:</td><td>{user.email}</td></tr>
                    {editTheme?
                    <tr><td>Theme:</td><td>
                        <input type = "color" name = "userTheme" list = "presetColors" value = {curUserTheme} onChange = {e => setUserTheme(e.currentTarget.value)}/>
                        <datalist id = "presetColors">
                            <option>#333333</option>
                            <option>#007BFF</option>
                            <option>#6C757D</option>
                            <option>#28A745</option>
                            <option>#DC3545</option>
                            <option>#FFC107</option>
                            <option>#17A2B8</option>
                            <option>#F8F9FA</option>
                            <option>#343A40</option>
                        </datalist>
                    </td></tr>
                    :null}
                </tbody>
            </table>
        </Modal>
    )
}